import React, { Component } from "react";
import Swal from "sweetalert2";
import "./Home.css";

export default class SsoCallback extends Component {
  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const pathId = this.props.match && this.props.match.params ? this.props.match.params.id : "";
    const id =
      pathId ||
      params.get("username") ||
      params.get("id") ||
      params.get("user") ||
      params.get("ticket") ||
      params.get("code");

    if (id) {
      window.location.replace("/rubrongkpru/Checklogin/" + encodeURIComponent(id));
      return;
    }

    Swal.fire("เข้าสู่ระบบไม่สำเร็จ", "ไม่พบข้อมูลผู้ใช้จาก SSO KPRU", "error").then(() => {
      window.location.href = "/rubrongkpru/";
    });
  }

  render() {
    return (
      <div className="login-page">
        <div className="login-card">
          <p className="login-sso-status">กำลังเข้าสู่ระบบด้วย SSO KPRU...</p>
        </div>
      </div>
    );
  }
}
